import { isArray, isNil, isValid } from "@visactor/vutils";

export const getPixelPropertyStr = (num, defaultStr) => isValid(num) ? isArray(num) ? num.map((n => `${n}px`)).join(" ") : `${num}px` : null != defaultStr ? defaultStr : "initial";

export const pixelPropertyStrToNumber = str => {
    const numArr = str.split(" ").map((n => Number.isNaN(n) ? Number.parseFloat(n.substring(0, n.length - 2)) : Number.parseFloat(n)));
    return 1 === numArr.length ? numArr[0] : numArr;
};

let cacheScrollbarWidth;

export const getScrollbarWidth = (container = document.body) => {
    if (isNil(cacheScrollbarWidth)) {
        const outer = document.createElement("div");
        outer.style.visibility = "hidden", outer.style.overflow = "scroll", container.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner), cacheScrollbarWidth = outer.offsetWidth - inner.offsetWidth, 
        outer.parentNode.removeChild(outer);
    }
    return cacheScrollbarWidth;
};
//# sourceMappingURL=common.js.map
